export default __webpack_public_path__ + "static/media/active.242a2334.svg";